<template>
    <div class="dark-blue hero-img">
    
      <v-container class="px-10 mt-lg-10 mt-xs-6 mt-sm-8 mt-md-8 pt-12 d-flex align-center justify-center fill-height" fluid>
        <v-row cols="12">
            <v-col cols="2"></v-col>
            <v-col cols="12" md="5" class="d-flex justify-center flex-column">
                <h1 class="section__header-title white--text text-h2 font-weight-bold">Government</h1>
                <h2 class="white--text text-h5 font-italic mb-5">Trusted Communications for Australian Government.</h2>
                <h2 class="white--text text-subtitle-1">Yabbr helps agencies move beyond compliance to genuine connection — secure, scalable, and tailored to the needs of government.
                </h2>
            </v-col>
            
        </v-row>
        
      </v-container>
    </div>
  </template>
  
<script>
    export default {
    name: 'GovHero',
    }
</script>

<style lang="scss" scoped>
.hero-img {

    background: #091531;
    width: 100%;
    height: 700px;
    position: relative;
    background-position: right;
    

    &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background-position: 80% 50%;
        background-image: url('../assets/img/gov-icon.png');
        z-index: 1;
    }
    * {
        z-index: 2;
    }

    > * {
        max-width: 2000px;
    }
    
}



</style>
  